export default "__VITE_ASSET__BKIrVvG3__"